"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vendorWithName = exports.vendorRead = void 0;
const first_1 = __importDefault(require("lodash/first"));
const Vendor_1 = require("../models/Vendor");
const expect_1 = __importDefault(require("../util/expect"));
const tryOrUndefined_1 = __importDefault(require("../util/tryOrUndefined"));
const PATH = 'vendors';
async function vendorRead(id, firestore) {
    const result = await firestore.read(PATH, id);
    return (0, Vendor_1.vendorDeserialize)(result.value, result.id);
}
exports.vendorRead = vendorRead;
async function vendorWithName(name, firestore) {
    var _a;
    const results = (_a = (await (0, tryOrUndefined_1.default)(firestore.list(PATH, { where: [['name', '==', name]] })))) !== null && _a !== void 0 ? _a : (await firestore.list(PATH, {
        where: [['nameMatches', 'array-contains', name]],
    }));
    const firstResult = (0, expect_1.default)((0, first_1.default)(results), 'a vendor result');
    return (0, Vendor_1.vendorDeserialize)(firstResult === null || firstResult === void 0 ? void 0 : firstResult.value, firstResult === null || firstResult === void 0 ? void 0 : firstResult.id);
}
exports.vendorWithName = vendorWithName;
